import React, { memo, FC, RefObject } from "react";
import styles from "./ScreenReaderOnly.scss";
import { withStyles } from "@core-ui/helpers/WithStyles";

interface ScreenReaderOnlyProps {
    text: string;
    id?: string;
    href?: string;
    as?: "div" | "span" | "p" | "a" | "button" | React.ComponentClass;
    onClick?: VoidFunction;
    compRef?: RefObject<any>;
}

const ScreenReaderOnly: FC<ScreenReaderOnlyProps> = ({
    text,
    as: Comp = "p",
    compRef,
    ...props
}: ScreenReaderOnlyProps) => {
    return (
        <Comp className={styles.screenReaderOnly} ref={compRef} {...props}>
            {text}
        </Comp>
    );
};

export default memo(withStyles(ScreenReaderOnly, styles));
